import type { ShippingGroup } from '@/domain';
import { strings } from '@/shared/strings';

/**
 * What each tab of the shipping screen is called, on the tab and on its figure
 * alike. The lab's request of 22 October 2026.
 */
export const SHIPPING_TAB_LABEL: Record<ShippingGroup, string> = {
  awaiting_payment: strings.shipping.waitingForAccounts,
  ready: strings.shipping.readyToDispatch,
  awaiting_tracking: strings.shipping.awaitingTracking,
  in_transit: strings.shipping.inTransit,
  delivered: strings.shipping.receivedGroup,
  held: strings.payments.onHold,
};

/** What an empty tab says, before anything is typed into the search. */
export const SHIPPING_TAB_EMPTY: Record<ShippingGroup, string> = {
  awaiting_payment: strings.shipping.noneWaiting,
  ready: strings.shipping.noneReady,
  awaiting_tracking: strings.shipping.noneAwaiting,
  in_transit: strings.shipping.noneInTransit,
  delivered: strings.shipping.noneReceived,
  held: strings.shipping.noneHeld,
};
